import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-fillin-response-dialog',
  templateUrl: './fillin-response-dialog.component.html',
  styleUrls: ['./fillin-response-dialog.component.scss'],
})
export class FillinResponseDialogComponent implements OnInit {
  status!: string;

  constructor(
    public dialogRef: MatDialogRef<FillinResponseDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
  ) {
    this.status = data.status;
    translate.setDefaultLang('en');
    const browserLang = translate.getBrowserLang() || 'en';
    translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');
  }

  notes = new FormControl('');

  ngOnInit(): void {}

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  onClickOK() {
    this.data['notes'] = this.notes?.value;
    this.dialogRef.close(this.data);
  }
}
